import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "End__Inner section__inner" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", { class: "End__Background color--1" }, null, -1)
const _hoisted_3 = { class: "End__Subinner section__subinner" }
const _hoisted_4 = { class: "End__Grid End__Main__Wrapper grid" }
const _hoisted_5 = { class: "End__Main" }
const _hoisted_6 = { class: "color--2" }
const _hoisted_7 = ["innerHTML"]
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", { class: "End__Next__Background color--5" }, null, -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", { class: "End__Next__Hover" }, null, -1)
const _hoisted_10 = { class: "End__Next__Inner" }
const _hoisted_11 = { key: 1 }
const _hoisted_12 = { class: "End__Next__Content" }
const _hoisted_13 = {
  key: 0,
  class: "End__Next__Meta small-uppercase color--3"
}
const _hoisted_14 = {
  key: 1,
  class: "End__Next__Meta small-uppercase color--3"
}
const _hoisted_15 = ["innerHTML"]
const _hoisted_16 = /*#__PURE__*/_createElementVNode("svg", {
  viewBox: "0 0 48 48",
  class: "End__Next__Icon"
}, [
  /*#__PURE__*/_createElementVNode("circle", {
    cx: "24",
    cy: "24",
    r: "24"
  }),
  /*#__PURE__*/_createElementVNode("path", { d: "M29.7519 23.168C30.3457 23.5638 30.3457 24.4362 29.7519 24.8321L20.5547 30.9635C19.8901 31.4066 19 30.9302 19 30.1315L19 17.8685C19 17.0698 19.8901 16.5934 20.5547 17.0365L29.7519 23.168Z" })
], -1)
const _hoisted_17 = { class: "End__Grid End__Visual__Wrapper grid" }
const _hoisted_18 = { class: "End__Visual" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("span", { class: "End__Visual__Background color--5" }, null, -1)
const _hoisted_20 = { class: "picture picture--2" }
const _hoisted_21 = ["srcset"]
const _hoisted_22 = ["src", "alt"]
const _hoisted_23 = { class: "picture picture--1" }
const _hoisted_24 = ["srcset"]
const _hoisted_25 = ["src", "alt"]
const _hoisted_26 = { class: "End__Grid End__Footer__Wrapper grid" }
const _hoisted_27 = { class: "End__Footer" }
const _hoisted_28 = /*#__PURE__*/_createElementVNode("svg", {
  viewBox: "0 0 64 64",
  class: "color--1"
}, [
  /*#__PURE__*/_createElementVNode("circle", {
    class: "border",
    opacity: "0.3",
    cx: "32",
    cy: "32",
    r: "31.5"
  }),
  /*#__PURE__*/_createElementVNode("g", null, [
    /*#__PURE__*/_createElementVNode("rect", {
      class: "alt",
      opacity: "0.5",
      width: "9.88718",
      height: "16.56",
      rx: "4.94359",
      transform: "matrix(0.991106 0.133077 -0.145537 0.989353 38.2012 24.3005)"
    })
  ]),
  /*#__PURE__*/_createElementVNode("g", null, [
    /*#__PURE__*/_createElementVNode("rect", {
      class: "alt",
      opacity: "0.5",
      width: "9.88717",
      height: "16.56",
      rx: "4.94359",
      transform: "matrix(0.991097 -0.133139 0.145469 0.989363 16 25.6162)"
    })
  ]),
  /*#__PURE__*/_createElementVNode("rect", {
    class: "center",
    x: "25.1445",
    y: "21.25",
    width: "13.8694",
    height: "20.4082",
    rx: "6.93472",
    "stroke-width": "1.5"
  })
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LazyPicture = _resolveComponent("LazyPicture")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("section", {
    class: _normalizeClass({ 'End': true, 'active': _ctx.active, 'dark': _ctx.themeForceDark })
  }, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("h2", _hoisted_6, _toDisplayString(_ctx.$t('chapter.congrats', { name: _ctx.userName})), 1),
            _createElementVNode("div", {
              class: "End__Main__Text color--4",
              innerHTML: _ctx.nextText
            }, null, 8, _hoisted_7),
            _createVNode(_component_router_link, {
              class: "End__Next",
              to: _ctx.nextTo
            }, {
              default: _withCtx(() => [
                _hoisted_8,
                _hoisted_9,
                _createElementVNode("span", _hoisted_10, [
                  (_ctx.chapter.end?.thumbnail?.url || _ctx.chapter.end.type === 'test')
                    ? (_openBlock(), _createBlock(_component_LazyPicture, {
                        key: 0,
                        image: _ctx.nextImage,
                        alt: _ctx.chapter.end.title,
                        class: "picture picture--appear"
                      }, null, 8, ["image", "alt"]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_11)),
                  _createElementVNode("span", _hoisted_12, [
                    (_ctx.chapter.end.type === 'chapter')
                      ? (_openBlock(), _createElementBlock("span", _hoisted_13, _toDisplayString(_ctx.$t( 'chapter.minutes', { minutes: _ctx.chapter.end.readTime })), 1))
                      : _createCommentVNode("", true),
                    (_ctx.chapter.end.type === 'course')
                      ? (_openBlock(), _createElementBlock("span", _hoisted_14, _toDisplayString(_ctx.$t( _ctx.chapter.end.nbChapters === 1 ? 'course.chapter' : 'course.chapters', { nb: _ctx.chapter.end.nbChapters })), 1))
                      : _createCommentVNode("", true),
                    _createElementVNode("h3", {
                      class: "color--2",
                      innerHTML: _ctx.chapter.end.type === 'test' ? _ctx.$t('chapter.knowledge_test_' + _ctx.chapter.category) : _ctx.chapter.end.title
                    }, null, 8, _hoisted_15)
                  ]),
                  _hoisted_16
                ])
              ]),
              _: 1
            }, 8, ["to"])
          ])
        ]),
        _createElementVNode("div", _hoisted_17, [
          _createElementVNode("div", _hoisted_18, [
            _hoisted_19,
            _createElementVNode("picture", _hoisted_20, [
              _createElementVNode("source", {
                srcset: `/images/chapter/end-${_ctx.chapter.end.type}-2.png 1x, /images/chapter/end-${_ctx.chapter.end.type}-2@2x.png 2x`
              }, null, 8, _hoisted_21),
              _createElementVNode("img", {
                src: `/images/chapter/end-${_ctx.chapter.end.type}-2.png`,
                alt: _ctx.chapter.title
              }, null, 8, _hoisted_22)
            ]),
            _createElementVNode("picture", _hoisted_23, [
              _createElementVNode("source", {
                srcset: `/images/chapter/end-${_ctx.chapter.end.type}-1.png 1x, /images/chapter/end-${_ctx.chapter.end.type}-1@2x.png 2x`
              }, null, 8, _hoisted_24),
              _createElementVNode("img", {
                src: `/images/chapter/end-${_ctx.chapter.end.type}-1.png`,
                alt: _ctx.chapter.title
              }, null, 8, _hoisted_25)
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_26, [
          _createElementVNode("footer", _hoisted_27, [
            _createVNode(_component_router_link, {
              class: "End__Back",
              to: _ctx.chapter.courseSlug ? `/course/${_ctx.chapter.courseSlug}` : '/courses'
            }, {
              default: _withCtx(() => [
                _hoisted_28,
                _createElementVNode("span", null, _toDisplayString(_ctx.$t('chapter.back')), 1)
              ]),
              _: 1
            }, 8, ["to"])
          ])
        ])
      ])
    ])
  ], 2))
}